import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-sand">
        <div className="text-navy/60">Chargement…</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user.role !== 'admin') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-sand pt-24">
        <div className="max-w-md text-center space-y-4">
          <h1 className="font-heading text-3xl text-navy">Accès refusé</h1>
          <p className="text-navy/70">
            Cette zone est réservée aux administrateurs.
          </p>
        </div>
      </div>
    );
  }

  return children;
};
